// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"9f87f14d","453":"1dc39131","667":"78d7ef7c","952":"f8308cb9","977":"7a306fb8"}[chunkId] + ".chunk.js";
};